export const architecturalPortfolioImages = [
  { src: '/images/architectural/hospital-1.jpg', caption: 'Hospital Design' },
  { src: '/images/architectural/hotel-1.jpg', caption: 'Hotel Design' },
  {
    src: '/images/architectural/school-rmg-ladvi.jpg',
    caption: 'RMG School at Ladvi',
  },
  {
    src: '/images/architectural/avalon-project.jpg',
    caption: 'Avalon Project',
  },
  { src: '/images/architectural/bungalow-1.jpg', caption: 'Bungalow Design' },
  { src: '/images/architectural/bungalow-2.jpg', caption: 'Luxury Bungalow' },
  { src: '/images/architectural/bungalow-3.jpg', caption: 'Modern Bungalow' },
  {
    src: '/images/architectural/bungalow-8.jpg',
    caption: 'Contemporary Bungalow',
  },
  { src: '/images/architectural/daman-project.jpg', caption: 'Daman Project' },
  { src: '/images/architectural/delhi-lowrise.jpg', caption: 'Delhi Lowrise' },
  { src: '/images/architectural/highrise-3.jpg', caption: 'Highrise Building' },
  { src: '/images/architectural/highrise-5.jpg', caption: 'Modern Highrise' },
  // {
  //   src: '/images/architectural/project-photo-1.jpg',
  //   caption: 'Luxurios Bedroom',
  // },
  {
    src: '/images/architectural/project-photo-2.jpg',
    caption: 'Bungalows for Patel brothers at Kamrej',
  },
  {
    src: '/images/architectural/project-photo-3.jpg',
    caption: '"OMKAAR"- Bungalow at Dumas',
  },
  { src: '/images/architectural/render-1.png', caption: 'Bungalow at Althan' },
  {
    src: '/images/architectural/render-2.jpeg',
    caption: 'Farmhouse at Hydrabad',
  },
  {
    src: '/images/architectural/render-3.png',
    caption: 'Deconstructive approach for villa',
  },
  {
    src: '/images/architectural/render-4.png',
    caption: 'Farmhouse at Dumas,Surat',
  },
  {
    src: '/images/architectural/project-photo-4.jpeg',
    caption: 'Bungalow at Dumas',
  },
  {
    src: '/images/architectural/project-photo-5.jpeg',
    caption: 'Bungalow at Vesu',
  },
  {
    src: '/images/architectural/project-photo-6.jpeg',
    caption: 'Bungalow at Pal',
  },
];
